import { StripePaymentForm } from 'widget/event_components/stripe-payment-form';
import { SquarePaymentForm } from 'widget/event_components/square-payment-form';
import { PayPalPaymentForm } from 'widget/event_components/paypal-payment-form';
import * as E from './elements';
import { PromoCode } from 'widget/event_components/Ticket/components/PromoCode';
import { TicketCheckoutSummaryForm } from 'widget/event_components/Ticket/components/Summary';
import { useEffect } from 'react';
import { trackCustomerInfo } from '../../../../../utils/journey-tracking';

export const Payment = (props) => {
  const { square, stripe } = props.payment;

  useEffect(() => {
    // Create an array of cart items for tracking
    const cartItems = Object.entries(props.cart).map(([ticketId, quantity]) => {
      const ticket = props.tickets.find((t) => t.get('id') === ticketId);
      return {
        ticket_name: ticket ? ticket.get('name') : 'Unknown Ticket',
        quantity,
      };
    });

    // Google Analytics tracking
    if (window.gtag) {
      window.gtag('event', 'add_to_cart', {
        event_category: 'Ticket',
        event_label: 'Cart Items',
        items: cartItems,
      });
    }

    // Facebook Pixel tracking
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_type: 'ticket',
        content_ids: cartItems.map((item) => item.ticket_name),
        contents: cartItems,
        currency: stripe ? stripe.currency : 'USD',
        value: props.checkoutValues.cartTotal,
      });
    }

    // Track customer info if available
    if (props.form && props.form.first_name && props.form.last_name && props.form.email) {
      trackCustomerInfo(props.event, {
        first_name: props.form.first_name,
        last_name: props.form.last_name,
        email: props.form.email,
      });
    }
  }, [props.form]);

  const paymentComponentMapping = {
    stripe: StripePaymentForm,
    square: SquarePaymentForm,
    paypal: PayPalPaymentForm,
  };

  const paymentExtraProps = (_paymentType) => {
    const paymentTypes = {
      stripe: {
        currency: stripe && stripe.currency,
        stripe_account_id: stripe && stripe.stripe_account_id,
        is_marketplace: stripe && stripe.is_marketplace,
        payment_methods: stripe && stripe.payment_methods,
      },
      square: {
        locationId: square && square.location_id,
        currency: square && square.currency,
      },
    };
    return paymentTypes[_paymentType];
  };

  if (+props.checkoutValues.cartTotal === 0) {
    return (
      <E.Wrapper>
        <div style={{ justifyContent: 'center', display: 'flex' }}>{props.children}</div>
      </E.Wrapper>
    );
  }
  const PaymentComponent = paymentComponentMapping[props.session.payment_type];
  if (!PaymentComponent) return <div>Payment not available. This could be because Stripe, Square, or PayPal has not been configured.</div>;

  return (
    <E.Wrapper>
      {props.settings.get('showPromoCode') && <PromoCode {...props} />}
      <TicketCheckoutSummaryForm {...props} />
      <PaymentComponent {...props} {...paymentExtraProps(props.paymentType)} ticketOverrides={props.ticketOverrides}>
        {props.children}
      </PaymentComponent>
    </E.Wrapper>
  );
};
